import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { AuthSignIn } from "@/components/features/auth/sign-in";

export const AuthSignInPage = () => {
	return (
		<PageMeta title="" url={PATHS.AUTH.SIGN_IN}>
			<AuthSignIn />
		</PageMeta>
	);
};
